const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GrowManagementQuery: any = {
    GetWarehouseList: Backofficebff + '/v1/grow/get-warehouse-list-by-countryId',
    GetGrowOpsLogs: Backofficebff + '/v1/grow/get-grow-ops-logs',
};
